import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _713c4bf0 = () => interopDefault(import('../pages/404.vue' /* webpackChunkName: "pages/404" */))
const _db28635c = () => interopDefault(import('../pages/help/afiliados.vue' /* webpackChunkName: "pages/help/afiliados" */))
const _ab4f3538 = () => interopDefault(import('../pages/live.vue' /* webpackChunkName: "pages/live" */))
const _623c7043 = () => interopDefault(import('../pages/virtual.vue' /* webpackChunkName: "pages/virtual" */))
const _4d917741 = () => interopDefault(import('../pages/virtual/_slug/index.vue' /* webpackChunkName: "pages/virtual/_slug/index" */))
const _1a576e08 = () => interopDefault(import('../pages/help/index.vue' /* webpackChunkName: "pages/help/index" */))
const _5688e420 = () => interopDefault(import('../pages/search.vue' /* webpackChunkName: "pages/search" */))
const _52db0751 = () => interopDefault(import('../pages/reset-password.vue' /* webpackChunkName: "pages/reset-password" */))
const _a1454e12 = () => interopDefault(import('../pages/competition.vue' /* webpackChunkName: "pages/competition" */))
const _c12038e8 = () => interopDefault(import('../pages/cookies-activation.vue' /* webpackChunkName: "pages/cookies-activation" */))
const _557bd822 = () => interopDefault(import('../pages/e-sports/index.vue' /* webpackChunkName: "pages/e-sports/index" */))
const _4d926789 = () => interopDefault(import('../pages/greyhounds/index.vue' /* webpackChunkName: "pages/greyhounds/index" */))
const _022334c6 = () => interopDefault(import('../pages/horse-racing_bak/index.vue' /* webpackChunkName: "pages/horse-racing_bak/index" */))
const _5f640f73 = () => interopDefault(import('../pages/login-pop-up.vue' /* webpackChunkName: "pages/login-pop-up" */))
const _00b669a1 = () => interopDefault(import('../pages/login.vue' /* webpackChunkName: "pages/login" */))
const _54e2d0c0 = () => interopDefault(import('../pages/outrights/index.vue' /* webpackChunkName: "pages/outrights/index" */))
const _eddae4f2 = () => interopDefault(import('../pages/page.vue' /* webpackChunkName: "pages/page" */))
const _1db732aa = () => interopDefault(import('../pages/pop-up-login.vue' /* webpackChunkName: "pages/pop-up-login" */))
const _2d58e9aa = () => interopDefault(import('../pages/promotions/index.vue' /* webpackChunkName: "pages/promotions/index" */))
const _e6f37d02 = () => interopDefault(import('../pages/promotion-bingol.vue' /* webpackChunkName: "pages/promotion-bingol" */))
const _75afbb0a = () => interopDefault(import('../pages/promotion-events.vue' /* webpackChunkName: "pages/promotion-events" */))
const _5c3306b6 = () => interopDefault(import('../pages/promotion-mini-game.vue' /* webpackChunkName: "pages/promotion-mini-game" */))
const _2d99f049 = () => interopDefault(import('../pages/promotion-missions.vue' /* webpackChunkName: "pages/promotion-missions" */))
const _5901adc4 = () => interopDefault(import('../pages/promotion-mundial.vue' /* webpackChunkName: "pages/promotion-mundial" */))
const _37b2fe4b = () => interopDefault(import('../pages/promotion-tournament.vue' /* webpackChunkName: "pages/promotion-tournament" */))
const _41126f37 = () => interopDefault(import('../pages/regions.vue' /* webpackChunkName: "pages/regions" */))
const _7e601fae = () => interopDefault(import('../pages/results.vue' /* webpackChunkName: "pages/results" */))
const _54ee898f = () => interopDefault(import('../pages/schedule.vue' /* webpackChunkName: "pages/schedule" */))
const _fd30fb12 = () => interopDefault(import('../pages/sports.vue' /* webpackChunkName: "pages/sports" */))
const _63c0b44a = () => interopDefault(import('../pages/support/index.vue' /* webpackChunkName: "pages/support/index" */))
const _00c59b36 = () => interopDefault(import('../pages/tournaments/index.vue' /* webpackChunkName: "pages/tournaments/index" */))
const _79d5014d = () => interopDefault(import('../pages/transactions.vue' /* webpackChunkName: "pages/transactions" */))
const _2dea691c = () => interopDefault(import('../pages/account/bets.vue' /* webpackChunkName: "pages/account/bets" */))
const _67f436fc = () => interopDefault(import('../pages/account/freebets_copy.vue' /* webpackChunkName: "pages/account/freebets_copy" */))
const _6bea7af0 = () => interopDefault(import('../pages/account/freebets.vue' /* webpackChunkName: "pages/account/freebets" */))
const _ccd54e22 = () => interopDefault(import('../pages/account/transactions.vue' /* webpackChunkName: "pages/account/transactions" */))
const _82125784 = () => interopDefault(import('../pages/auth/account.vue' /* webpackChunkName: "pages/auth/account" */))
const _2cdc71d4 = () => interopDefault(import('../pages/auth/forgot-password.vue' /* webpackChunkName: "pages/auth/forgot-password" */))
const _7bac20e2 = () => interopDefault(import('../pages/auth/register.vue' /* webpackChunkName: "pages/auth/register" */))
const _5b141710 = () => interopDefault(import('../pages/auth/registration.vue' /* webpackChunkName: "pages/auth/registration" */))
const _bcd4d150 = () => interopDefault(import('../pages/auth/reset-password.vue' /* webpackChunkName: "pages/auth/reset-password" */))
const _ff92de6c = () => interopDefault(import('../pages/help/contact.vue' /* webpackChunkName: "pages/help/contact" */))
const _b4b77aea = () => interopDefault(import('../pages/help/sport-rules/index.vue' /* webpackChunkName: "pages/help/sport-rules/index" */))
const _b824bd7a = () => interopDefault(import('../pages/help/sport-rules/_slug.vue' /* webpackChunkName: "pages/help/sport-rules/_slug" */))
const _49560c44 = () => interopDefault(import('../pages/BAK/sport/_slug.vue' /* webpackChunkName: "pages/BAK/sport/_slug" */))
const _0fe752c0 = () => interopDefault(import('../pages/e-sports/match/_id.vue' /* webpackChunkName: "pages/e-sports/match/_id" */))
const _3074fda2 = () => interopDefault(import('../pages/BAK/sport/_id/_slug.vue' /* webpackChunkName: "pages/BAK/sport/_id/_slug" */))
const _47a59972 = () => interopDefault(import('../pages/BAK/sportssss/_region/_competition.vue' /* webpackChunkName: "pages/BAK/sportssss/_region/_competition" */))
const _7e057948 = () => interopDefault(import('../pages/BAK/sportssss/_region/_competition/outrights.vue' /* webpackChunkName: "pages/BAK/sportssss/_region/_competition/outrights" */))
const _1b9043c6 = () => interopDefault(import('../pages/BAK/sportssss/_region/_competition/_id.vue' /* webpackChunkName: "pages/BAK/sportssss/_region/_competition/_id" */))
const _1dc4b098 = () => interopDefault(import('../pages/help/_slug.vue' /* webpackChunkName: "pages/help/_slug" */))
const _601e5972 = () => interopDefault(import('../pages/competitions/_slug.vue' /* webpackChunkName: "pages/competitions/_slug" */))
const _c5000856 = () => interopDefault(import('../pages/e-sports/_sport.vue' /* webpackChunkName: "pages/e-sports/_sport" */))
const _58dcc788 = () => interopDefault(import('../pages/events/_id.vue' /* webpackChunkName: "pages/events/_id" */))
const _847eb26e = () => interopDefault(import('../pages/greyhounds/_venue.vue' /* webpackChunkName: "pages/greyhounds/_venue" */))
const _c96cfda8 = () => interopDefault(import('../pages/horse-racing_bak/_venue.vue' /* webpackChunkName: "pages/horse-racing_bak/_venue" */))
const _751e0208 = () => interopDefault(import('../pages/outrights/_id.vue' /* webpackChunkName: "pages/outrights/_id" */))
const _4a7d3a26 = () => interopDefault(import('../pages/promotions/_slug/index.vue' /* webpackChunkName: "pages/promotions/_slug/index" */))
const _620a1302 = () => interopDefault(import('../pages/support/_slug.vue' /* webpackChunkName: "pages/support/_slug" */))
const _99c2f62a = () => interopDefault(import('../pages/promotions/_slug/activity.vue' /* webpackChunkName: "pages/promotions/_slug/activity" */))
const _728e3463 = () => interopDefault(import('../pages/match/_id/_slug.vue' /* webpackChunkName: "pages/match/_id/_slug" */))
const _6b6aa658 = () => interopDefault(import('../pages/events/_sport/_region/_competition.vue' /* webpackChunkName: "pages/events/_sport/_region/_competition" */))
const _b75fdd0c = () => interopDefault(import('../pages/outrights/_sport/_region/_competition/outrights.vue' /* webpackChunkName: "pages/outrights/_sport/_region/_competition/outrights" */))
const _2cc5f862 = () => interopDefault(import('../pages/outrights/_sport/_region/_competition/_id.vue' /* webpackChunkName: "pages/outrights/_sport/_region/_competition/_id" */))
const _370ec68a = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _37131b30 = () => interopDefault(import('../pages/_sport/index.vue' /* webpackChunkName: "pages/_sport/index" */))
const _9a145fd6 = () => interopDefault(import('../pages/_sport/_competition/index.vue' /* webpackChunkName: "pages/_sport/_competition/index" */))
const _81a9212a = () => interopDefault(import('../pages/_sport/_competition/outrights/index.vue' /* webpackChunkName: "pages/_sport/_competition/outrights/index" */))
const _03145093 = () => interopDefault(import('../pages/_sport/_competition/outrights/_id.vue' /* webpackChunkName: "pages/_sport/_competition/outrights/_id" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/404/",
    component: _713c4bf0,
    pathToRegexpOptions: {"strict":true},
    name: "404___es"
  }, {
    path: "/afiliados/",
    component: _db28635c,
    pathToRegexpOptions: {"strict":true},
    name: "help-afiliados___es"
  }, {
    path: "/apuestas-en-directo/",
    component: _ab4f3538,
    pathToRegexpOptions: {"strict":true},
    name: "live___es"
  }, {
    path: "/apuestas-virtuales/",
    component: _623c7043,
    pathToRegexpOptions: {"strict":true},
    name: "virtual___es",
    children: [{
      path: ":slug?/",
      component: _4d917741,
      pathToRegexpOptions: {"strict":true},
      name: "virtual-slug___es"
    }]
  }, {
    path: "/ayuda/",
    component: _1a576e08,
    pathToRegexpOptions: {"strict":true},
    name: "help___es"
  }, {
    path: "/buscar/",
    component: _5688e420,
    pathToRegexpOptions: {"strict":true},
    name: "search___es"
  }, {
    path: "/cambia-la-contrasena/",
    component: _52db0751,
    pathToRegexpOptions: {"strict":true},
    name: "reset-password___es"
  }, {
    path: "/competition/",
    component: _a1454e12,
    pathToRegexpOptions: {"strict":true},
    name: "competition___es"
  }, {
    path: "/cookies-activation/",
    component: _c12038e8,
    pathToRegexpOptions: {"strict":true},
    name: "cookies-activation___es"
  }, {
    path: "/e-sports/",
    component: _557bd822,
    pathToRegexpOptions: {"strict":true},
    name: "e-sports___es"
  }, {
    path: "/greyhounds/",
    component: _4d926789,
    pathToRegexpOptions: {"strict":true},
    name: "greyhounds___es"
  }, {
    path: "/horse-racing_bak/",
    component: _022334c6,
    pathToRegexpOptions: {"strict":true},
    name: "horse-racing_bak___es"
  }, {
    path: "/login-pop-up/",
    component: _5f640f73,
    pathToRegexpOptions: {"strict":true},
    name: "login-pop-up___es"
  }, {
    path: "/login/",
    component: _00b669a1,
    pathToRegexpOptions: {"strict":true},
    name: "login___es"
  }, {
    path: "/outrights/",
    component: _54e2d0c0,
    pathToRegexpOptions: {"strict":true},
    name: "outrights___es"
  }, {
    path: "/page/",
    component: _eddae4f2,
    pathToRegexpOptions: {"strict":true},
    name: "page___es"
  }, {
    path: "/pop-up-login/",
    component: _1db732aa,
    pathToRegexpOptions: {"strict":true},
    name: "pop-up-login___es"
  }, {
    path: "/promociones/",
    component: _2d58e9aa,
    pathToRegexpOptions: {"strict":true},
    name: "promotions___es"
  }, {
    path: "/promotion-bingol/",
    component: _e6f37d02,
    pathToRegexpOptions: {"strict":true},
    name: "promotion-bingol___es"
  }, {
    path: "/promotion-events/",
    component: _75afbb0a,
    pathToRegexpOptions: {"strict":true},
    name: "promotion-events___es"
  }, {
    path: "/promotion-mini-game/",
    component: _5c3306b6,
    pathToRegexpOptions: {"strict":true},
    name: "promotion-mini-game___es"
  }, {
    path: "/promotion-missions/",
    component: _2d99f049,
    pathToRegexpOptions: {"strict":true},
    name: "promotion-missions___es"
  }, {
    path: "/promotion-mundial/",
    component: _5901adc4,
    pathToRegexpOptions: {"strict":true},
    name: "promotion-mundial___es"
  }, {
    path: "/promotion-tournament/",
    component: _37b2fe4b,
    pathToRegexpOptions: {"strict":true},
    name: "promotion-tournament___es"
  }, {
    path: "/regions/",
    component: _41126f37,
    pathToRegexpOptions: {"strict":true},
    name: "regions___es"
  }, {
    path: "/resultados/",
    component: _7e601fae,
    pathToRegexpOptions: {"strict":true},
    name: "results___es"
  }, {
    path: "/schedule/",
    component: _54ee898f,
    pathToRegexpOptions: {"strict":true},
    name: "schedule___es"
  }, {
    path: "/sports/",
    component: _fd30fb12,
    pathToRegexpOptions: {"strict":true},
    name: "sports___es"
  }, {
    path: "/support/",
    component: _63c0b44a,
    pathToRegexpOptions: {"strict":true},
    name: "support___es"
  }, {
    path: "/tournaments/",
    component: _00c59b36,
    pathToRegexpOptions: {"strict":true},
    name: "tournaments___es"
  }, {
    path: "/transactions/",
    component: _79d5014d,
    pathToRegexpOptions: {"strict":true},
    name: "transactions___es"
  }, {
    path: "/account/bets/",
    component: _2dea691c,
    pathToRegexpOptions: {"strict":true},
    name: "account-bets___es"
  }, {
    path: "/account/freebets_copy/",
    component: _67f436fc,
    pathToRegexpOptions: {"strict":true},
    name: "account-freebets_copy___es"
  }, {
    path: "/account/freebets/",
    component: _6bea7af0,
    pathToRegexpOptions: {"strict":true},
    name: "account-freebets___es"
  }, {
    path: "/account/transactions/",
    component: _ccd54e22,
    pathToRegexpOptions: {"strict":true},
    name: "account-transactions___es"
  }, {
    path: "/auth/account/",
    component: _82125784,
    pathToRegexpOptions: {"strict":true},
    name: "auth-account___es"
  }, {
    path: "/auth/forgot-password/",
    component: _2cdc71d4,
    pathToRegexpOptions: {"strict":true},
    name: "auth-forgot-password___es"
  }, {
    path: "/auth/register/",
    component: _7bac20e2,
    pathToRegexpOptions: {"strict":true},
    name: "auth-register___es"
  }, {
    path: "/auth/registration/",
    component: _5b141710,
    pathToRegexpOptions: {"strict":true},
    name: "auth-registration___es"
  }, {
    path: "/auth/reset-password/",
    component: _bcd4d150,
    pathToRegexpOptions: {"strict":true},
    name: "auth-reset-password___es"
  }, {
    path: "/ayuda/contacto/",
    component: _ff92de6c,
    pathToRegexpOptions: {"strict":true},
    name: "help-contact___es"
  }, {
    path: "/ayuda/reglas-deportivas/",
    component: _b4b77aea,
    pathToRegexpOptions: {"strict":true},
    name: "help-sport-rules___es"
  }, {
    path: "/ayuda/reglas-deportivas/:slug/",
    component: _b824bd7a,
    pathToRegexpOptions: {"strict":true},
    name: "help-sport-rules-slug___es"
  }, {
    path: "/BAK/sport/:slug?/",
    component: _49560c44,
    pathToRegexpOptions: {"strict":true},
    name: "BAK-sport-slug___es"
  }, {
    path: "/e-sports/match/:id/",
    component: _0fe752c0,
    pathToRegexpOptions: {"strict":true},
    name: "e-sports-match-id___es"
  }, {
    path: "/BAK/sport/:id?/:slug?/",
    component: _3074fda2,
    pathToRegexpOptions: {"strict":true},
    name: "BAK-sport-id-slug___es"
  }, {
    path: "/BAK/sportssss/:region?/:competition?/",
    component: _47a59972,
    pathToRegexpOptions: {"strict":true},
    name: "BAK-sportssss-region-competition___es",
    children: [{
      path: "outrights/",
      component: _7e057948,
      pathToRegexpOptions: {"strict":true},
      name: "BAK-sportssss-region-competition-outrights___es"
    }, {
      path: ":id?/",
      component: _1b9043c6,
      pathToRegexpOptions: {"strict":true},
      name: "BAK-sportssss-region-competition-id___es"
    }]
  }, {
    path: "/ayuda/:slug/",
    component: _1dc4b098,
    pathToRegexpOptions: {"strict":true},
    name: "help-slug___es"
  }, {
    path: "/competitions/:slug?/",
    component: _601e5972,
    pathToRegexpOptions: {"strict":true},
    name: "competitions-slug___es"
  }, {
    path: "/e-sports/:sport/",
    component: _c5000856,
    pathToRegexpOptions: {"strict":true},
    name: "e-sports-sport___es"
  }, {
    path: "/events/:id?/",
    component: _58dcc788,
    pathToRegexpOptions: {"strict":true},
    name: "events-id___es"
  }, {
    path: "/greyhounds/:venue/",
    component: _847eb26e,
    pathToRegexpOptions: {"strict":true},
    name: "greyhounds-venue___es"
  }, {
    path: "/horse-racing_bak/:venue?/",
    component: _c96cfda8,
    pathToRegexpOptions: {"strict":true},
    name: "horse-racing_bak-venue___es"
  }, {
    path: "/outrights/:id/",
    component: _751e0208,
    pathToRegexpOptions: {"strict":true},
    name: "outrights-id___es"
  }, {
    path: "/promociones/:slug/",
    component: _4a7d3a26,
    pathToRegexpOptions: {"strict":true},
    name: "promotions-slug___es"
  }, {
    path: "/support/:slug/",
    component: _620a1302,
    pathToRegexpOptions: {"strict":true},
    name: "support-slug___es"
  }, {
    path: "/promociones/:slug/actividad/",
    component: _99c2f62a,
    pathToRegexpOptions: {"strict":true},
    name: "promotions-slug-activity___es"
  }, {
    path: "/match/:id?/:slug?/",
    component: _728e3463,
    pathToRegexpOptions: {"strict":true},
    name: "match-id-slug___es"
  }, {
    path: "/events/:sport?/:region?/:competition?/",
    component: _6b6aa658,
    pathToRegexpOptions: {"strict":true},
    name: "events-sport-region-competition___es"
  }, {
    path: "/outrights/:sport/:region?/:competition?/outrights/",
    component: _b75fdd0c,
    pathToRegexpOptions: {"strict":true},
    name: "outrights-sport-region-competition-outrights___es"
  }, {
    path: "/outrights/:sport/:region?/:competition?/:id?/",
    component: _2cc5f862,
    pathToRegexpOptions: {"strict":true},
    name: "outrights-sport-region-competition-id___es"
  }, {
    path: "/",
    component: _370ec68a,
    pathToRegexpOptions: {"strict":true},
    name: "index___es"
  }, {
    path: "/:sport/",
    component: _37131b30,
    pathToRegexpOptions: {"strict":true},
    name: "sport___es"
  }, {
    path: "/:sport/:competition/",
    component: _9a145fd6,
    pathToRegexpOptions: {"strict":true},
    name: "sport-competition___es"
  }, {
    path: "/:sport/:competition/outrights/",
    component: _81a9212a,
    pathToRegexpOptions: {"strict":true},
    name: "sport-competition-outrights___es"
  }, {
    path: "/:sport/:competition/outrights/:id/",
    component: _03145093,
    pathToRegexpOptions: {"strict":true},
    name: "sport-competition-outrights-id___es"
  }, {
    path: "/:sport/:competition?/:slug?/",
    component: _728e3463,
    alias: "/match-screen",
    pathToRegexpOptions: {"strict":true},
    name: "match-screen___es"
  }, {
    path: "/*/",
    component: _eddae4f2
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
